"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import TomSelect from "tom-select/dist/cjs/tom-select.popular";
document.addEventListener("DOMContentLoaded", () => {
  const tagContainers = document.querySelectorAll("#proposals_list");
  tagContainers.forEach((container) => {
    const { tmName, tmItems, tmNoResults } = container.dataset;
    const config = {
      plugins: ["remove_button", "dropdown_input"],
      allowEmptyOption: true,
      items: JSON.parse(tmItems),
      render: __spreadValues({
        item: (data, escape) => `<div>${escape(data.text)}<input type="hidden" name="${tmName}[]" value="${data.value}" /></div>`
      }, tmNoResults && { no_results: () => `<div class="no-results">${tmNoResults}</div>` })
    };
    return new TomSelect(container, config);
  });
});
